import { request } from "./request";

/*获取所有厂商信息*/
export function brand() {
  return request({
    url: "/get_factorydata",
  });
}

/*根据厂商id查询其系列*/
export function series(factId) {
  return request({
    method: "GET",
    url: "/get_seriesdata",
    params: {
      factId,
    },
  });
}

/* 获取本体数据 */
export function spedataAll(s) {
  return request({
    method: "GET",
    url: "/get_spedata_all",
    params: {
      s,
    },
  });
}
/* 获取附件数据 */
export function accdataAll(s) {
  return request({
    method: "GET",
    url: "/get_accdata_all",
    params: {
      s,
    },
  });
}

/* 获取全局搜索数据 */
export function search(inputstr) {
  return request({
    method: "POST",
    url: "/get_data_search",
    headers: {
      "Content-type": "application/json;charset=UTF-8",
    },
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    data: inputstr,
  });
}

/* 获取相似系列数据 */
export function alike(factid, seriesid) {
  return request({
    method: "GET",
    url: "/get_series_similar",
    params: {
      seriesid,
      factid,
    },
  });
}
